<div class="paywall-simulate-payment">
  <span class="paywall-simulate-payment__badge">Test mode</span>
  <h2>Simulate payment</h2>
  <p>This paywall is in test mode. No card is charged, but the purchase is completed as if it had been paid.</p>

  @if (paywallService.selectedChargePlan()?.name) {
    <p class="paywall-simulate-payment__plan">{{ paywallService.selectedChargePlan()?.name }}</p>
  }
  @if (payment(); as payment) {
    @if (payment.tax) {
      <div class="paywall-simulate-payment__lines">
        <div class="paywall-simulate-payment__line"><span>Subtotal</span><span>{{ format(payment.subtotal) }}</span></div>
        <div class="paywall-simulate-payment__line"><span>Tax</span><span>{{ format(payment.tax) }}</span></div>
      </div>
    }
    <p class="paywall-simulate-payment__amount">{{ format(payment.amount) }}</p>
    @if (payment.tax) {
      <p class="paywall-simulate-payment__note">Total including tax, as the buyer would be charged.</p>
    }
  }

  <div class="paywall-simulate-payment__actions">
    <button type="button" class="paywall-simulate-payment__pay" [disabled]="cancelling()" (click)="simulatePayment()">
      Simulate successful payment
    </button>
    <button type="button" class="paywall-simulate-payment__cancel" [disabled]="cancelling()" (click)="cancelPayment()">
      @if (cancelling()) {
        <span>Cancelling...</span>
      } @else {
        <span>Cancel payment</span>
      }
    </button>
  </div>

  @if (error()) {
    <div class="paywall-simulate-payment__error" role="alert">{{ error() }}</div>
  }
</div>
